import { render, staticRenderFns } from "./overlay-wrapper.component.vue?vue&type=template&id=1094acd2&"
import script from "./overlay-wrapper.component.vue?vue&type=script&lang=ts&"
export * from "./overlay-wrapper.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports